"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShowProductUpdatedLabel = void 0;
const date_fns_1 = require("date-fns");
const SHOW_LABEL_THRESHOLD_SECONDS = 60;
const useShowProductUpdatedLabel = (updatedAt) => {
    const secondsSinceUpdate = (0, date_fns_1.differenceInSeconds)(Date.now(), new Date(updatedAt));
    return secondsSinceUpdate < SHOW_LABEL_THRESHOLD_SECONDS;
};
exports.useShowProductUpdatedLabel = useShowProductUpdatedLabel;
